module.exports = __webpack_public_path__ + "img/img-47.505d381d.png";